module.exports = __webpack_public_path__ + "img/logo.24b74110.svg";